var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.$route.meta.headerVisible)?_c('HeaderView'):_vm._e(),_c('div',{staticClass:"main"},[_c('ContentView'),(_vm.$route.meta.footerVisible)?_c('FooterView'):_vm._e()],1),_c('el-backtop',{attrs:{"bottom":_vm.isMobile && _vm.isMobile.length ? 100 : 50,"right":50}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }